document.addEventListener("DOMContentLoaded", function () {
  var productFormButtons = document.querySelector(".product-form");
  var stickyAddToCart = document.querySelector(".sticky-addtocart");
  var originalParent = productFormButtons.parentElement;

  window.addEventListener("scroll", function () {
    var scrollPosition = window.scrollY;

    if (scrollPosition > 400) {
      if (!stickyAddToCart.contains(productFormButtons)) {
        stickyAddToCart.appendChild(productFormButtons);
        stickyAddToCart.style.display = "block";
      }
    } else {
      if (stickyAddToCart.contains(productFormButtons)) {
        originalParent.appendChild(productFormButtons);
        stickyAddToCart.style.display = "none";
      }
    }
  });
});
